class PoBlogLinkSticky extends HTMLElement {
  constructor() {
    super();
    this.bar = null;
    this.placeholder = null;
    this.startY = 0;
    this.isFixed = false;
  }

  connectedCallback() {
    this.bar = this.querySelector('section');
    if (!this.bar) return;

    this.init();
  }

  init() {
    // Calcola la posizione iniziale
    this.startY = this.bar.getBoundingClientRect().top + window.scrollY;

    // Crea placeholder
    this.placeholder = document.createElement('div');
    this.placeholder.style.display = 'none';

    // Gestisci scroll
    window.addEventListener('scroll', this.handleScroll.bind(this));
    
    // Gestisci resize
    window.addEventListener('resize', this.handleResize.bind(this));

    // Inizializza
    this.handleScroll();
  }

  handleScroll() {
    const scrollY = window.scrollY || window.pageYOffset;

    if (!this.isFixed && scrollY >= this.startY) {
      this.isFixed = true;
      this.placeholder.style.height = this.bar.offsetHeight + 'px';
      this.placeholder.style.display = 'block';
      this.bar.parentNode.insertBefore(this.placeholder, this.bar);

      this.bar.classList.add('tw-fixed', 'tw-left-0', 'tw-right-0', 'tw-z-[30]');
      this.bar.style.top = '0';
    } else if (this.isFixed && scrollY < this.startY) {
      this.isFixed = false;
      if (this.placeholder.parentNode) {
        this.placeholder.parentNode.removeChild(this.placeholder);
      }
      this.bar.classList.remove('tw-fixed', 'tw-left-0', 'tw-right-0', 'tw-z-[30]');
      this.bar.style.top = '';
    }
  }

  handleResize() {
    this.startY = this.bar.getBoundingClientRect().top + window.scrollY;
    if (this.isFixed) {
      this.placeholder.style.height = this.bar.offsetHeight + 'px';
      this.bar.style.top = '0';
    }
  }
}

customElements.define('po-blog-link-sticky', PoBlogLinkSticky);
